

export default class CustomSwiper {

	constructor(selector, settings) {
		this.selector = selector;
		this.settings = settings;
	}

	init() {
		const containers = document.querySelectorAll(this.selector);

		containers.forEach((container) => {
			const slides = container.querySelector('.swiper');
			const clickPrev = container.querySelectorAll('.click-prev');
			const clickNext = container.querySelectorAll('.click-next');
			const numberCurrent = container.querySelector('.number-current');

			const swiper = new Swiper(slides, this.settings);

			clickPrev.forEach((button) => {
				button.addEventListener(
					'click',
					(e) => {
						e.preventDefault();
						swiper.slidePrev();
					}
				);
			});

			clickNext.forEach((button) => {
				button.addEventListener(
					'click',
					(e) => {
						e.preventDefault();
						swiper.slideNext();
					}
				);
			});

			swiper.on('slideChange', function () {
				if ( numberCurrent )
					numberCurrent.innerHTML = swiper.realIndex + 1;
			});
		});
	}

}
